import { React, useState, useEffect, useRef } from "react";
import MiscUploadPDFView from "../misc_components/MiscUploadPDFView";
import Footer from "../Footer";
import NavBar from "../NavBar";
import MiscPageTitle from "../misc_components/MiscPageTitle";
import MiscPageMidSection from "../misc_components/MiscPageMidSection";
import HomeScreenHowToUse from "../home_screen/HomeScreenHowToUse";
import MiscWhyUse from "../misc_components/MiscWhyUse";
import MiscPageLookingFor from "../misc_components/MiscPageLookingFor";
import LoadingBar from "react-top-loading-bar";
import { useLocation, ScrollRestoration } from "react-router-dom";
import { PageContext } from "../../App";
import MiscDownloadOnAppStore from "../misc_components/MiscDownloadOnAppStore";
import FlattenPDFImageListScreen from "./FlattenPDFImageListScreen";
import { BASE_URL } from "../Config";

function FlattenPDFMain() {
  //location
  const location = useLocation();
  // Use optional chaining or a guard in case state is undefined
  const { title } = location.state || { title: "Flatten PDF For Free" };

  //selected files
  const [selectedFiles, setSelectedFiles] = useState([]);
  //show edit screen
  const [showEditFileScreen, setShowEditFileScreen] = useState(false);
  //start processing
  const [startProcessingFiles, setStartProcessingFiles] = useState(false);

  //reference loading bar
  const loadingBarRef = useRef(null);

  //looking for object
  //requires 3 data objects
  //to show keywarded navigation
  const lookingForObject = {
    data1: { link: "/flatten_pdf", title: "Uneditable PDF" },
    data2: { link: "/flatten_pdf", title: "Merge PDF Layers" },
    data3: { link: "/flatten_pdf", title: "Flatten PDF File Online" },
  };

  //use effect to handle the submit button click
  useEffect(() => {
    //check
    if (startProcessingFiles === true) {
      //show file edit screen
      setShowEditFileScreen(true);

      console.log(
        "Start file processing. Number of files: ",
        selectedFiles.length
      );
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [startProcessingFiles]);

  return (
    <PageContext.Provider
      value={{
        selectedFiles,
        setSelectedFiles,
        startProcessingFiles,
        setStartProcessingFiles,
        setShowEditFileScreen,
      }}
    >
      {/* Scroll to top */}
      <ScrollRestoration />
      {/* Loading Bar */}
      <LoadingBar ref={loadingBarRef} />

      {/*Add title and metadata */}
      <title>{title + " Offline"}</title>
      <meta name="robots" content="index, follow"></meta>
      <link
        rel="canonical"
        href={`${BASE_URL}${lookingForObject.data1.link}`}
      />
      <meta
        name="description"
        content="Flatten PDF online instantly. Merge layers, secure forms, and convert interactive PDFs into static files quickly with our easy PDF flatten tool."
      ></meta>
      <meta
        name="keywords"
        content="flatten PDF, PDF flatten tool, flatten PDF online, merge PDF layers, secure PDF forms, convert PDF to static, interactive PDF to PDF, PDF editor online, PDF management tool, compress PDF layers, flatten interactive PDF, PDF file optimizer, online PDF flatten, PDF document tool, flatten PDF forms"
      ></meta>

      {/* page content */}
      {showEditFileScreen ? (
        <FlattenPDFImageListScreen title={title}></FlattenPDFImageListScreen>
      ) : (
        <div>
          {/* Nav Bar */}
          <NavBar />
          {/* Title */}
          <MiscPageTitle title={title} online={false} />
          {/* Upload PDF View */}
          <MiscUploadPDFView
            selectMultiple={true}
            filetype={{ "application/pdf": [".pdf"] }}
          />
          {/* Mid Section */}
          <MiscPageMidSection description="Our Flatten PDF Offline website offers a secure, fast, and reliable solution to flatten PDF files both offline and online, making your documents permanent, non-editable, and ready for sharing or submission. Designed for professionals, students, and businesses, this powerful tool allows you to convert interactive PDFs into static files by merging layers, annotations, form fields, and comments into a single fixed layout. With offline functionality, all PDF flattening is processed directly on your device, ensuring complete privacy without uploading files to external servers. When internet access is available, users can also flatten PDF online using a smooth, browser-based interface for quick results. Whether you need to flatten PDF form fields before submitting official documents or lock annotations and signatures, this tool guarantees accurate output without altering the original appearance. The platform supports flatten PDF online for free, allowing users to process documents easily without complex setup or subscriptions. Using advanced flattening technology, the tool preserves text clarity, formatting, and visual integrity while preventing further edits. Compatible with desktop and mobile devices, this website helps you flatten PDF free, secure finalized documents, and ensure compatibility with government portals, job applications, and business workflows. If you are searching for the best flatten PDF offline tool, flatten PDF online, flatten PDF online for free, flatten PDF free, or an efficient way to flatten PDF form files securely, this platform delivers a complete, user-friendly, and privacy-first PDF solution." />
          {/* How to use */}
          <HomeScreenHowToUse
            steps={{
              step1: "Select",
              step2: "Offline",
              step3: "Flatten",
              step4: "Download",
            }}
          />
          {/* Why use section */}
          <MiscWhyUse
            title="Flatten PDF Tool"
            why_use={[
              {
                title: "Make PDFs Final and Non-Editable",
                description:
                  "Flattening PDFs converts interactive elements into a fixed layout, making documents non-editable and final. A flatten PDF tool ensures your files are ready for official submission and sharing.",
              },
              {
                title: "Secure Form Data and Signatures",
                description:
                  "When you flatten PDF form files, all filled fields, checkboxes, and digital signatures become permanent, preventing accidental changes or data loss.",
              },
              {
                title: "Improve Compatibility Across Devices",
                description:
                  "Some PDF viewers do not support layers or form elements properly. Using flatten PDF online ensures documents open and display correctly on all devices and platforms.",
              },
              {
                title: "Preserve Layout and Formatting",
                description:
                  "Flattening merges layers, annotations, and comments into one layer, maintaining the original layout. A flatten PDF online for free tool prevents formatting issues.",
              },
              {
                title: "Avoid Errors During Online Submissions",
                description:
                  "Many government portals and job application sites require static PDFs. Using a flatten PDF free solution helps avoid upload rejections caused by editable content.",
              },
              {
                title: "Protect Sensitive Information",
                description:
                  "Flattening locks the content in place, reducing the risk of unauthorized edits. A flatten PDF offline tool adds an extra level of document security.",
              },
              {
                title: "Ensure Accurate Printing Results",
                description:
                  "Flattened PDFs print exactly as they appear on screen. Using a flatten PDF form tool ensures all annotations and filled data appear correctly in printouts.",
              },
              {
                title: "Simplify Sharing and Collaboration",
                description:
                  "When sharing finalized documents, a flatten PDF online tool ensures recipients view the content as intended without modifying it.",
              },
              {
                title: "Save Time in Document Workflows",
                description:
                  "Flattening PDFs removes the need for repeated checks and revisions. A fast flatten PDF free tool speeds up document processing.",
              },
            ]}
          />
          {/* Download on Appsroe */}
          <MiscDownloadOnAppStore
            id={`https://apps.apple.com/app-bundle/id${1863317370}`}
          />
          {/* Looking for section */}
          <MiscPageLookingFor data={lookingForObject} />
          {/* Footer */}
          <Footer />
        </div>
      )}
    </PageContext.Provider>
  );
}

export default FlattenPDFMain;
